import React from "react";

//Import Assets
import "./badge.scss";
import {BADGES_TYPE} from "../../../constants/constTypes";

export function Badge(props) {
    const {type} = props
    const badge = BADGES_TYPE[type];
    return badge ?<div className={'badge'}
                         style={{
                             backgroundColor: badge.bgColor,
                             color: badge.textColor,
                         }}>
        {badge.title || ""}
    </div> : ""
}

